const positioning = [
  {
    icon: "ri-focus-3-line",
    title: "网站定位",
    desc: "面向想第一时间掌握动态的普通读者，做一份“看得懂经过”的爆料资讯站，而不是情绪化的信息流。",
  },
  {
    icon: "ri-compass-3-line",
    title: "发展理念",
    desc: "先用快讯满足“第一时间”，再用完整梳理满足“看懂因果”。快和准之间，我们选择把两者分开表达。",
  },
  {
    icon: "ri-group-line",
    title: "与读者共建",
    desc: "读者的投稿是内容的重要来源。每一条被采用的线索，编辑都会回一条确认，说明处理结果。",
  },
];

export default function Positioning() {
  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-8 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <p className="text-xs font-medium tracking-widest text-accent-700">POSITION · 定位与理念</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            一个专注现场的资讯站
          </h2>
        </div>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-3 lg:col-span-8">
          {positioning.map((item) => (
            <article key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-50 text-primary-600">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}